import { generateRouteByType } from "./NotificationsGenerateRoute";

const STATUS = [
  // {id: '0', name: 'backlog', accessor: 'backlog', visible: true},
  // {id: "1", name: "queue", accessor: 'queue', visible: true},
  // {id: "2", name: "rejected", accessor: 'rejected', visible: true},
  {id: "3", name: "queue", accessor: 'queue', visible: true},
  {id: "4", name: "in progress", accessor: 'in_progress', visible: true},
  {id: "5", name: "completed", accessor: 'completed', visible: true},
  {id: "6", name: "turned in", accessor: 'turned_in', visible: true},
]

const STATUS_LIBRARY = {
  'backlog': {id: '0'},
  'queue': {id: '1'},
  'rejected': {id: '2'},
  'created': {id: '3'},
  'in_progress': {id: '4'},
  'completed': {id: '5'},
  'turned_in': {id: '6'},
}

/**
 * @description
 * this method receives a number such as 1, 2 or 9 and returns the same number but as a string in base10.
 * @example
 * 1 -> '01'
 * 9 -> '09'
 * 10 -> '10'
 * @param  {number} number
 * @return {string}
 */
function mappedToBase10(number) {
  const numberFormated = number < 10 ? `0${number}` : number
  return numberFormated;
}

function getPlainHour(date = '') {
  const _date = date ? new Date(date) : new Date();
  return `${mappedToBase10(_date.getHours())}:${mappedToBase10(_date.getMinutes())}`
}

function getDate(date = '') {
  const _date = date ? new Date(date) : new Date();
  const month = mappedToBase10(_date.getMonth() + 1);
  const day = mappedToBase10(_date.getDate());
  const year = _date.getFullYear();
  return `${year}-${month}-${day}`
}

function secondsToMiliseconds(seconds) {
  return seconds*1000
}

export {getDate, getPlainHour, secondsToMiliseconds, STATUS, STATUS_LIBRARY, generateRouteByType}
